import Cookie from '../helpers/Cookie';

;$(function() {
	$('.view-options__button').click(function() {
		let container = $(this).parents('.sorting').parent();
		switch ($(this).data('list-type')) {
			case 'grid':
				// container.find('.card-list__list').addClass('card-list__list_3x');
				container.find('.card-list__list').addClass('card-list__list_4x');
				container.find('.card').addClass('card_small');
				Cookie.set('view-option', 'grid', {expires: 7*24*60*60});
				break;
			case 'tiles':
				// container.find('.card-list__list').removeClass('card-list__list_3x');
				container.find('.card-list__list').removeClass('card-list__list_4x');
				container.find('.card').removeClass('card_small');
				Cookie.delete('view-option');
				break;
		}
		$(this).parents('.sorting').find('.view-options__button_active').removeClass('view-options__button_active');
		$(this).addClass('view-options__button_active');
	});
});